export enum CardTypeEnum {
    EasyPaisa ="Easypaisa",
    JazzCash = "Jazzcash",
    JazzCashV2 = "Jazzcash_V2",
    Ajar = "Ajar",
    AjarToEasyPaisa = "AjarToEasyPaisa",
    AjarToJazzCash = "AjarToJazzCash",
    Sahulatpay = "Sahulatpay",
    SahulatpayToEasyPaisa = "SahulatpayToEasyPaisa",
    SahulatpayToJazzCash = "SahulatpayToJazzCash",
    BankCard = "BankCard",
    SadapayCard = "SadapayCard",
    OpayCard = "OpayCard"
}
